/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PickFootnoteRow } from './PickFootnoteRow';
import type { PickRow } from './PickRow';
import type { TeamRow } from './TeamRow';
export type PickAssetRow = {
    id: number;
    teamId: number;
    team: TeamRow;
    year: number;
    round: number;
    type: PickAssetRow.type;
    priority: number | null;
    protectedStart: number | null;
    protectedEnd: number | null;
    contingentOn: string | null;
    fallbackOn: string | null;
    picks: Array<PickRow>;
    footnotes: Array<PickFootnoteRow>;
};
export namespace PickAssetRow {
    export enum type {
        UNPROTECTED_PICK = 'UNPROTECTED_PICK',
        PICK_PROTECTION = 'PICK_PROTECTION',
        PROTECTED_PICK = 'PROTECTED_PICK',
        FAVORABLE = 'FAVORABLE',
        SWAP = 'SWAP',
    }
}

